import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.5.2_dc6d16290aedbb78aa0bca699d71fb43/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}